<template>
    <div id="totals-metric" class="tile" :class="[{ 'is-parent': isParent }, metricSize]">
        <article class="tile is-child notification is-white metric metric-primary metric-fixed system-counts" v-if="init">
            <b-loading :is-full-page="false" :active.sync="loading" :can-cancel="false"></b-loading>
            <div class="columns is-mobile">
                <div class="column">
                    <p class="title">{{ theTitle }}</p>
                </div>
                <div class="column">
                    <span class="company">{{ init.auth_user.company.name }}</span>
                </div>
            </div>
            <div class="columns is-mobile is-multiline" v-if="!loading">
                <div class="column is-3-desktop is-6-mobile" v-for="(stat, index) in chartData" v-bind:key="`tm-${index}`">
                    <div class="system-stat" :class="[{'has-link': link(stat.model)}, stat.model]" v-on:click="handleLink(stat.model)">
                        <b-icon :icon="stat.icon" size="is-large"></b-icon>
                        <p class="total">
                            <countTo :startVal="0" :endVal="stat.total" :duration='2000'></countTo>
                        </p>
                        <p class="total-label">{{ stat.label }}</p>
                    </div>
                </div>
            </div>
        </article>
    </div>
</template>

<script>
import { mapState } from 'vuex'
import countTo from 'vue-count-to'

export default {
  name: 'TotalsMetric',
  components: {
    countTo
  },
  props: {
    metric: {
      type: String
    },
    title: {
      type: String,
      default: 'Totals'
    },
    metricSize: {
      default: 'is-4',
      type: String
    },
    isParent: {
      default: true,
      type: Boolean
    }
  },
  data () {
    return {
      //
    }
  },
  watch: {
    modelUpdatedAt: function () {
      if (this.dataChanged === 'data') {
        this.getMetric()
      }
    }
  },
  computed: {
    ...mapState({
      metrics: state => state.metrics.all,
      init: state => state.init.all,
      modelUpdatedAt: state => state.modelUpdatedAt,
      dataChanged: state => state.dataChanged
    }),
    theTitle () {
      if (this.chartData.title !== undefined) return this.chartData.title
      return this.title
    },
    noDataMessage () {
      if (this.chartData.empty !== undefined) return this.chartData.empty
      return 'Not enough data to render chart.'
    },
    chartData () {
      if (this.metrics[this.metric] === undefined) return {}
      return this.metrics[this.metric].statistics
    },
    loading () {
      if (typeof this.chartData !== 'object') return true
      return Object.keys(this.chartData).length === 0
    },
    hasChartData () {
      if (this.loading) return false
      if (typeof this.chartData !== 'object') return false
      if (Object.keys(this.chartData).length === 0) return false

      return true
    }
  },
  methods: {
    forceRerender () {
      this.renderIcon = false

      this.$nextTick(() => {
        this.renderIcon = true
      })
    },
    getMetric (force) {
      if (!force) force = false

      this.$store.dispatch('metrics/getMetric', { metric: this.metric, qs: { force: force } }).then(() => {
        this.forceRerender()
      })
    },
    link (model) {
      const link = this.$router.resolve({ name: model })
      return !!(link && link.href !== '/')
    },
    handleLink (model) {
      if (!this.link(model)) return
      this.$router.push({ name: model })
    }
  },
  created () {
    this.getMetric()
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Metrics/TotalsMetric.vue